import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import './stores/theme'
import boogi from '@boogi/ui'

import { createWebHistory, createRouter } from 'vue-router'

import SignIn from './views/auth/SignIn.vue'
import TwoFactor from './views/auth/TwoFactor.vue'
import ForgotPassword from './views/auth/ForgotPassword.vue'
import ResetPassword from './views/auth/ResetPassword.vue'
import DashboardLayout from './layouts/DashboardLayout.vue'
import AuthLayout from './layouts/AuthLayout.vue'

import { DataTable } from '@boogi/ui'

import { jwtDecode } from 'jwt-decode'
import LaunchPad from './views/LaunchPad.vue'
import Dashboard01 from './views/dashboard-01/Dashboard01.vue'
import RetailerCatalogue from './views/retailer-catalogue/RetailerCatalogue.vue'
import RetailerPage from './views/retailer-catalogue/RetailerPage.vue'
import OfferPage from './views/retailer-catalogue/OfferPage.vue'

import CashbackLedger from './views/cashback-program/CashbackLedger.vue'
import TransactionEnrichment from './views/monitoring/TransactionEnrichment.vue'
import TransactionUpload from './views/monitoring/TransactionUpload.vue'
import BankConnections from './views/monitoring/BankConnections.vue'

import BillingPage from './views/monitoring/BillingPage.vue'
import APIPage from './views/integration/APIPage.vue'
import WebhookPage from './views/integration/WebhookPage.vue'
import WebhookDetail from './views/integration/Webhook.vue'
import Playground from './views/integration/Playground.vue'

import ProgramOffers from './views/cashback-program/ProgramOffers.vue'
import PayoutsPage from './views/cashback-program/PayoutsPage.vue'
import Join from './views/auth/Join.vue'

import Settings from './views/dashboard/Settings.vue'
import SpendExplorer from './views/share-of-wallet/SpendExplorer.vue'
import AddOfferPage from './views/retailer-catalogue/AddOfferPage.vue'
import StepRetailer from './views/retailer-catalogue/add-offer/StepRetailer.vue'
import StepTransaction from './views/retailer-catalogue/add-offer/StepTransaction.vue'
import StepMids from './views/retailer-catalogue/add-offer/StepMids.vue'
import StepOfferInfo from './views/retailer-catalogue/add-offer/StepOfferInfo.vue'
import StepCashback from './views/retailer-catalogue/add-offer/StepCashback.vue'
import TransactionVerification from './views/retailer-catalogue/TransactionVerification.vue'
import YourOffersCatalogue from './views/retailer-catalogue/YourOffersCatalogue.vue'
import api from './utils/api'
import CategoryExplorer from './views/share-of-wallet/CategoryExplorer.vue'
import Audience from './views/audience/CustomerSegments.vue'
import Segment from './views/audience/Segment.vue'
import UsersList from './views/audience/UsersList.vue'
import UserDetail from './views/audience/UserDetail.vue'

import AudienceBuilder from './views/audience/AudienceBuilder.vue'
import CampaignBuilder from './views/campaign/CampaignBuilder.vue'

import SDKPage from './views/integration/SDK.vue'
import SDKPreview from './views/integration/SDKPreview.vue'
import WhitelabelSite from './views/integration/WhitelabelSite.vue'

import WhitelabelSites from './views/integration/WhitelabelSites.vue'
import WhitelabelThemes from './views/integration/WhitelabelThemes.vue'
import WhitelabelThemeDetail from './views/integration/WhitelabelThemeDetail.vue'
import EditOfferPage from './views/retailer-catalogue/EditOfferPage.vue'
import SupportTickets from './views/support/SupportTickets.vue'
import SupportTicket from './views/support/SupportTicket.vue'
import ProductCatalogue from './views/product/ProductCatalogue.vue'
import ProductPage from './views/product/ProductPage.vue'
import ProductFulfillment from './views/product/ProductFulfillment.vue'
import ProductInventory from './views/product/ProductInventory.vue'
import GiftCards from './views/product/GiftCards.vue'
import GiftCardOrders from './views/product/GiftCardOrders.vue'
import BoogiIntelligence from './views/cashback-program/BoogiIntelligence.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    children: [
      { path: '', component: Dashboard01 },
      { path: '/launchpad', component: LaunchPad },

      // ===== Cashback program =====
      { path: '/cashback-program/program-offers', component: ProgramOffers },
      { path: '/cashback-program/campaign-builder', component: CampaignBuilder },
      { path: '/cashback-program/offer-catalogue', component: RetailerCatalogue },
      { path: '/cashback-program/custom-offers', component: YourOffersCatalogue },

      // ===== Perks and rewards =====
      { path: '/perks-and-rewards/product-catalogue', component: ProductCatalogue },
      { path: '/perks-and-rewards/inventory', component: ProductInventory },

      // ===== Gift cards =====
      { path: '/gift-cards', component: GiftCards },
      { path: '/gift-cards/orders', component: GiftCardOrders },
      { path: '/gift-cards/catalogue', redirect: '/gift-cards' },
      { path: '/gift-cards/activations', redirect: '/gift-cards' },

      // ===== Settlements and orders =====
      { path: '/cashback-program/settlements', component: PayoutsPage },
      { path: '/cashback-program/ledger', component: CashbackLedger },
      
      { path: '/intelligence', component: BoogiIntelligence },

      { path: '/perks-and-rewards/product-orders', component: ProductFulfillment },

      // ===== Enrolled users =====
      { path: '/enrolled-users/users', component: UsersList },
      { path: '/enrolled-users/users/:userId', component: UserDetail },
      { path: '/enrolled-users/user-segments', component: Audience },

      // ===== Monitoring =====
      { path: '/transaction-processing', component: TransactionEnrichment },
      { path: '/transaction-processing/uploads', component: TransactionUpload },
      { path: '/monitoring/cashback-ledger', redirect: '/cashback-program/ledger' },
      { path: '/monitoring/bank-connections', component: BankConnections },

      // ===== Developers =====
      { path: '/developers/api-keys', component: APIPage },
      { path: '/developers/sdk-manager', component: SDKPage },
      { path: '/developers/playground', component: Playground },
      { path: '/developers/webhooks', component: WebhookPage },
      { path: '/developers/webhooks/:webhookId', component: WebhookDetail },

      // ===== Whitelabel =====
      { path: '/whitelabel', redirect: '/whitelabel/sites' },
      { path: '/whitelabel/sites', component: WhitelabelSites },
      { path: '/whitelabel/sites/:id', component: WhitelabelSite },
      { path: '/whitelabel/themes', component: WhitelabelThemes },
      { path: '/whitelabel/themes/:id', component: WhitelabelThemeDetail },

      // ===== Support =====
      { path: '/support', component: SupportTickets },
      { path: '/support/:ticketId', component: SupportTicket },

      // ===== Detail / wizard / standalone routes =====
      { path: '/retailer/:retailerId', component: RetailerPage },
      { path: '/retailer/:retailerId/offer/:offerId', component: OfferPage },
      {
        path: '/add-offer',
        component: AddOfferPage,
        redirect: '/add-offer/retailer',
        children: [
          { path: 'retailer', component: StepRetailer },
          { path: 'transaction', component: StepTransaction },
          { path: 'mids', component: StepMids },
          { path: 'info', component: StepOfferInfo },
          { path: 'rules', component: StepCashback },
        ],
      },
      { path: '/edit-offer/:offerId', component: EditOfferPage },
      { path: '/fulfilment', component: TransactionVerification },
      { path: '/spend-explorer', component: SpendExplorer },
      { path: '/spend-explorer/:category', component: CategoryExplorer },
      { path: '/enrolled-users/user-segments/:segmentId', component: Segment },
      { path: '/end-users/uploads', redirect: '/enrolled-users/user-segments' },
      { path: '/user-segments', redirect: '/enrolled-users/user-segments' },
      {
        path: '/user-segments/:segmentId',
        redirect: (to) => `/enrolled-users/user-segments/${to.params.segmentId}`,
      },
      { path: '/enrolled-users/segment', redirect: '/enrolled-users/user-segments' },
      {
        path: '/enrolled-users/segment/:segmentId',
        redirect: (to) => `/enrolled-users/user-segments/${to.params.segmentId}`,
      },
      { path: '/audience-builder', component: AudienceBuilder },
      { path: '/perks-and-rewards/product-catalogue/:productId', component: ProductPage },
      { path: '/monitoring/transaction-enrichment/uploads', redirect: '/transaction-processing' },
      { path: '/sdk-preview', component: SDKPreview },
      { path: '/settings', component: Settings },
      { path: '/billing', component: BillingPage },

      // ===== Redirects from previous flat URLs (keep old links working) =====
      { path: '/program-offers', redirect: '/cashback-program/program-offers' },
      { path: '/campaign-builder', redirect: '/cashback-program/campaign-builder' },
      { path: '/offer-catalogue', redirect: '/cashback-program/offer-catalogue' },
      { path: '/retailer-catalogue', redirect: '/cashback-program/offer-catalogue' },
      { path: '/offer-approvals', redirect: '/cashback-program/program-offers' },
      { path: '/retailer-approvals', redirect: '/cashback-program/program-offers' },
      { path: '/custom-offers', redirect: '/cashback-program/custom-offers' },
      { path: '/your-catalogue', redirect: '/cashback-program/custom-offers' },
      { path: '/product-catalogue', redirect: '/perks-and-rewards/product-catalogue' },
      {
        path: '/product-catalogue/:productId',
        redirect: (to) => `/perks-and-rewards/product-catalogue/${to.params.productId}`,
      },
      { path: '/product-inventory', redirect: '/perks-and-rewards/inventory' },
      { path: '/perks-and-rewards/product-inventory', redirect: '/perks-and-rewards/inventory' },
      { path: '/gift-card-catalogue', redirect: '/gift-cards' },
      { path: '/gift-card-activations', redirect: '/gift-cards' },
      { path: '/gift-card-orders', redirect: '/gift-cards/orders' },
      // Previous nested location, kept so existing links keep working.
      {
        path: '/perks-and-rewards/gift-card-catalogue',
        redirect: '/gift-cards',
      },
      {
        path: '/perks-and-rewards/gift-card-activations',
        redirect: '/gift-cards',
      },
      { path: '/perks-and-rewards/gift-card-orders', redirect: '/gift-cards/orders' },
      { path: '/payouts', redirect: '/cashback-program/settlements' },
      { path: '/settlements/payouts', redirect: '/cashback-program/settlements' },
      { path: '/product-invoices', redirect: '/perks-and-rewards/product-orders' },
      { path: '/settlements/product-invoices', redirect: '/perks-and-rewards/product-orders' },
      { path: '/settlements/product-orders', redirect: '/perks-and-rewards/product-orders' },
      { path: '/segment', redirect: '/enrolled-users/user-segments' },
      {
        path: '/segment/:segmentId',
        redirect: (to) => `/enrolled-users/user-segments/${to.params.segmentId}`,
      },
      { path: '/monitoring/transaction-enrichment', redirect: '/transaction-processing' },
      { path: '/transaction-enrichment', redirect: '/transaction-processing' },
      { path: '/transaction-enrichment/uploads', redirect: '/transaction-processing' },
      { path: '/cashback-ledger', redirect: '/cashback-program/ledger' },
      { path: '/bank-connections', redirect: '/monitoring/bank-connections' },
      { path: '/api-keys', redirect: '/developers/api-keys' },
      { path: '/sdk-manager', redirect: '/developers/sdk-manager' },
      { path: '/playground', redirect: '/developers/playground' },
      { path: '/webhooks', redirect: '/developers/webhooks' },
      {
        path: '/webhooks/:webhookId',
        redirect: (to) => `/developers/webhooks/${to.params.webhookId}`,
      },
    ],
    beforeEnter: async (to, from, next) => {
      const token = localStorage.getItem('token')
      if (!token) {
        sessionStorage.setItem('redirectPath', to.path)
        next('/auth/sign-in')
      } else {
        var { exp } = jwtDecode(token)
        var now = Date.now() / 1000

        if (exp < now) {
          sessionStorage.setItem('redirectPath', to.path)
          next('/auth/sign-in')
        } else {
          next()
        }
      }
    },
  },
  {
    path: '/',
    component: AuthLayout,
    children: [
      { path: '/auth/login', redirect: '/auth/sign-in' },
      { path: '/auth/sign-in', component: SignIn },
      { path: '/auth/join/:id', component: Join },
      { path: '/auth/forgot-password', component: ForgotPassword },
      { path: '/auth/reset-password/:id', component: ResetPassword },
      { path: '/auth/two-factor', component: TwoFactor },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

// Ensure apiUrl and apiType are always set before any component reads them
if (!localStorage.getItem('apiUrl')) {
  localStorage.setItem('apiUrl', process.env.VUE_APP_API_URL)
}
if (!localStorage.getItem('apiType')) {
  localStorage.setItem('apiType', process.env.VUE_APP_API_TYPE)
}

var app = createApp(App)
app.use(router)
app.use(api)
app.use(boogi)
app.component('EasyDataTable', DataTable)
app.component('DataTable', DataTable)

// Mount the app
app.mount('#app')
